import {injectFont} from "@/FunctionKit.js"
import {setScreenResolution} from "@/Screen.js"
import {handleExtenedUrl} from "@/ExtendUrl.js"
import {searchByWorkstationIdApi, getLastVersionApi} from "@/RoseRepo.js"

	import replace from 'lodash-es/replace';
	import { nextTick } from 'vue'
	const urlMap = [
	    {
	        'path': '/web/portal',
	        'url': '/web/portal.sys/'
	    },
	    {
	        'path': '/web/portal/',
	        'url': '/web/portal.sys/'
	    }
	];
	const checkAuth = () => {
	    const token = localStorage.getItem('oauth-token');
	    return Boolean(token);
	};
	export const initTopIframe = async (id, _topDocument,_FontFace) =>
	{
	    try 
	    {
	        const body = _topDocument.getElementsByTagName('body');
	        const iframe = _topDocument.createElement('iframe');
	        iframe.id = 'codigger-main'+(id || '');
	        iframe.height = '100%'
	        iframe.width = '100%'
	        body[0].appendChild(iframe);
	        nextTick(()=> {
	            injectFont(iframe,_FontFace,_topDocument)
	        })
	        return iframe;
	    } 
	    catch (error) 
	    {
	        console.log('%c [ error ]', 'background:#F2F9FC; color:#0088CC', error);
	    }
	};
    const handleCollectionParam = () =>
    {
	    const token = localStorage.getItem('oauth-token');
	    const base64Data = token.split('.');
	    const userInfo = JSON.parse(decodeURIComponent(escape(window.atob(base64Data[1].replace(/-/g, '+').replace(/_/g, '/')))));
	    const sessionStorageKey = `${userInfo.username}_codigger_curCollection`;
        if (document.location.href.includes('collection='))
        {
            const searchParams = new URLSearchParams(document.location.href.substr(document.location.href.indexOf('?') + 1));
            sessionStorage.setItem(sessionStorageKey, searchParams.get('collection') || 'Collection1');
        }
        else
        {
            const curCollection = sessionStorage.getItem(sessionStorageKey);
            if(!curCollection || curCollection.indexOf('Collection') === -1)
            {
                sessionStorage.setItem(sessionStorageKey, 'Collection1');
            }
        }
    }
	export const getIframeUrl = async (url) =>
	{
	    if (!url) return '/web/portal.sys/';
	    for (let i = 0; i < urlMap.length; i++)
	    {
	        const value = urlMap[i];
	        if(url.indexOf(value.path) > -1)
	        {
	            return replace(url, value.path, value.url);
	        }
	    }
        if (checkAuth())
        {
            handleCollectionParam();
        }
	    if ([
            '/web/desktop',
            '/web/desktop/',
            '/web/empower',
            '/web/empower/',
            '/web/empower.sys',
            '/web/empower.sys/'
        ].includes(location.pathname) || url.indexOf('/web/empower.sys')>-1)
        {
            if (!checkAuth()) return '/web/portal.sys/';
            const {moduleVersion} = await searchByWorkstationIdApi({'moduleName': 'raw-codigger-empower'});
            return `/web/empower.sys/${moduleVersion}/`;
        }
	    return await handleExtenedUrl(url);
	};
	export const changeIframe = async (url = '') =>
	{
	    let myUrl = await getIframeUrl(url);
	    if(!myUrl) return;
	    const baseUrl = '';
	    return new Promise(async (resolve) =>
	    {
	        const topDoc = top.document
	        const _FontFace = FontFace
	        const hasIframe = topDoc.getElementById('codigger-main');
	        const target = !hasIframe ? await initTopIframe('', topDoc, _FontFace) : hasIframe;
	        if (myUrl.indexOf('http') < 0)
	        {
	            myUrl = baseUrl + myUrl;
	        }
	        if (target.src !== myUrl)
	        {
	            target.src = myUrl;
	        }
	        resolve();
	    });
	};

